function isAbsoluteUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

function isHttpBaseUrl(url: URL): boolean {
  return url.protocol === 'http:' || url.protocol === 'https:';
}

/**
 * Playwright's APIRequestContext accepts a relative request URL, but its
 * Set-Cookie parser later calls new URL(response.url). When response.url is
 * still relative, cookie-bearing responses fail before callers can inspect the
 * HTTP result. Resolve relative request URLs against the active page origin
 * first, matching the workflow navigation convention for portable paths.
 */
export function resolveBrowserContextRequestUrl(url: string, pageUrl: string | null): string {
  if (isAbsoluteUrl(url) || !pageUrl) {
    return url;
  }

  let base: URL;
  try {
    base = new URL(pageUrl);
  } catch {
    return url;
  }

  if (!isHttpBaseUrl(base)) {
    return url;
  }

  const normalizedPath = url.startsWith('//') || url.startsWith('/') ? url : `/${url}`;

  try {
    return new URL(normalizedPath, base.origin).toString();
  } catch {
    return url;
  }
}
